module.exports = __webpack_public_path__ + "img/4.417ac5ab.png";